export default __webpack_public_path__ + "static/media/orderbook.2a48d294.svg";